import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLogEnteredPage } from '@bingads-webui-campaign-react/shared-app-capi';
import { useWizardService, getCurrentStepId, getCurrentFlow } from '@bingads-webui-react/wizard-core';
import { isTestEnvironment } from '@bingads-webui-campaign/global-app-init';
import { omniturePageLoad } from './marketing-utils';

export const SignupFlowStepLogger = ({
  flow, activity, stepToPage, getSubFlowFromCurrentFlow, signUpPrefix,
}) => {
  const { state } = useWizardService();
  const currentStepId = getCurrentStepId(state);
  const currentFlow = getCurrentFlow(state);
  const subFlow = getSubFlowFromCurrentFlow(currentFlow);

  if (!stepToPage[currentStepId]) {
    activity.error(`Cannot find the step name from stepToPage: ${currentStepId}`);

    if (isTestEnvironment(document.domain)) {
      throw new Error('The current step is not in stepToPage config.');
    }
  }

  useLogEnteredPage({ Flow: flow, SubFlow: subFlow, Page: stepToPage[currentStepId] || 'unknown step' });

  useEffect(() => {
    omniturePageLoad({
      isSignUp: true,
      pageId: stepToPage[currentStepId] || 'unknown step',
      pageTitle: currentStepId,
      signUpPrefix,
    });
  }, [currentStepId, signUpPrefix, stepToPage]);

  return null;
};


SignupFlowStepLogger.propTypes = {
  activity: PropTypes.shape({ error: PropTypes.func }).isRequired,
  flow: PropTypes.string.isRequired,
  stepToPage: PropTypes.shape({}).isRequired,
  getSubFlowFromCurrentFlow: PropTypes.func,
  signUpPrefix: PropTypes.string.isRequired,
};

SignupFlowStepLogger.defaultProps = {
  getSubFlowFromCurrentFlow: () => null,
};
